export const debounce = <T extends unknown[]>(func: (...args: T) => void, timeout = 700) => {
    let timer: number
    return (...args: T): void => {
        clearTimeout(timer)
        timer = window.setTimeout(() => { func.apply(this, args) }, timeout)
    }
}
